import { Button, Col, Form, Modal, Row, Tooltip } from "antd";
import { useState } from "react";
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import imageApi from "api/image";
import certificateApi from "api/certificate";

export default function ModalDelete({ row, onSearch, openNotificationWithIcon }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation()

  const [loading, setLoading] = useState(false);

  const onFinish = async () => {
    try {
      setLoading(true);
      row.fileId && await imageApi.deleteImage(row.fileId);
      await certificateApi.delete(row._id);
      onSearch();
      onCancel();
      openNotificationWithIcon("success", t('notification'), t('deleteSuccess'));
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <>
      <Tooltip title={t('deleteCertificate')}>
        <Button danger onClick={() => setOpenModal(true)}>
          <DeleteOutlined />
        </Button>
      </Tooltip>

      <Modal
        open={openModal}
        title={t('deleteCertificate')}
        centered
        footer={null}
        onCancel={onCancel}
        width={400}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <h2 style={{ color: 'red' }}>{t('sureToDelete')}</h2>
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button danger style={{ width: "100%" }} htmlType="submit" loading={loading}>
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel} disabled={loading}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
